export default __webpack_public_path__ + "static/media/how_to_play_icon_2.8feffc90.png";